const healthLanding = {
  title: "Health",
  subtitle: "A personal knowledge base for the long game — the small, boring decisions that compound over decades.",
  intro: [
    "I am not a doctor, a nutritionist, or a fitness influencer. I am a software engineer and a father who started paying attention to health a little later than I should have — and now I am trying to make up for it with consistency rather than intensity.",
    "Most of what matters in health is not complicated. Eat real food. Move your body. Sleep enough. Manage stress before it manages you. The hard part is not knowing what to do — it is doing it, day after day, when no one is watching and the results are invisible.",
    "This section is where I collect what I have learned from books, podcasts, conversations with doctors, and my own trial and error. It is not medical advice. It is one person's attempt to think clearly about the body he has to live in for the next fifty years."
  ],
  howToUse: [
    {
      title: "Long-Term Principles",
      description: "The foundational ideas I keep coming back to — things that stay true regardless of which diet is trending.",
      path: "/health/principles"
    },
    {
      title: "By Age",
      description: "What to prioritize in your 20s, 30s, 40s, and beyond — because the playbook changes as you age.",
      path: "/health/by-age"
    },
    {
      title: "Food & Nutrient Search",
      description: "A quick reference for what is in the foods I actually eat — protein, fibre, micronutrients, and where to find them.",
      path: "/health/food"
    }
  ],
  philosophy: [
    { text: "Minimize added sugar — it is the single most impactful dietary change most people can make.", link: "/health/sugar" },
    { text: "Prioritize protein and fibre at every meal. They keep you full, they build and repair, and they are hard to overeat.", link: "/health/principles" },
    { text: "Resistance train regardless of age. Muscle is the organ of longevity — you either build it or you lose it.", link: "/health/principles" },
    { text: "Sleep is not a luxury. It is the foundation everything else is built on — mood, metabolism, decision-making, immunity.", link: "/health/principles" },
    { text: "Consistency beats intensity every single time. A 20-minute walk every day is worth more than a gym session you do once a month.", link: "/health/principles" },
    { text: "Whole foods over supplements. Get your nutrients from dal, eggs, vegetables, and fruit before reaching for a pill.", link: "/health/food" },
    { text: "Cook more. Eating out is fine, but the moment you cook your own food, you control what goes into your body.", link: "/health/food" },
    { text: "Do not drink your calories. Juices, sodas, sweetened chai — they add up fast and do not register as food.", link: "/health/sugar" },
    { text: "Learn to read labels. The ingredients list tells you more than the front of the package ever will.", link: "/health/sugar" },
    { text: "Health is not a destination. There is no finish line. It is just showing up, again and again, and making slightly better choices than yesterday." }
  ],
  sugarSection: {
    title: "Understanding Sugar",
    description: "A deep dive into added sugar — where it hides, what it does to your body over time, and how to reduce it without making life miserable.",
    path: "/health/sugar"
  }
};

export default healthLanding;
